import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { listProjects } from "@/lib/api";

const Ctx = createContext(null);
export const useProject = () => useContext(Ctx) || { projects: [], activeProject: null, activeId: "", setActiveId: () => {}, refreshProjects: () => {} };

export function ProjectProvider({ children }) {
  const [projects, setProjects] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem("adac-active-project") || "");

  const refresh = useCallback(() => listProjects().then(setProjects).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    if (activeId) localStorage.setItem("adac-active-project", activeId);
    else localStorage.removeItem("adac-active-project");
  }, [activeId]);

  const activeProject = projects.find((p) => p.id === activeId) || null;
  return (
    <Ctx.Provider value={{ projects, activeProject, activeId, setActiveId, refreshProjects: refresh }}>
      {children}
    </Ctx.Provider>
  );
}
